import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Sistema } from '../../_models/sistema';
import { SistemaService } from '../../_services/sistema.service';

@Component( {
  selector: 'app-sistema-listado',
  templateUrl: 'sistema-listado.component.html'
} )

export class SistemaListadoComponent implements OnInit {

  lisSistemas: Sistema[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  descripcion: string;
  mosDescripcion = false;

  constructor( private sisServicio: SistemaService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/sistemas' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'id', header: this.navServicio.buscarMensaje( 'SISTEMAS.LBL_IDSISTEMA' ), sort: false },
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'SISTEMAS.LBL_CODIGO' ), sort: false },
      { field: 'nombreSistema', header: this.navServicio.buscarMensaje( 'SISTEMAS.LBL_NOMBRE' ), sort: false },
      { field: 'descripcionCorta', header: this.navServicio.buscarMensaje( 'SISTEMAS.LBL_DESCRIPCION' ), sort: false },
      { field: 'token', header: this.navServicio.buscarMensaje( 'SISTEMAS.LBL_TOKEN' ), sort: false },
      { field: 'indicadorCreacion', header: this.navServicio.buscarMensaje( 'SISTEMAS.LBL_INDICADORCREACION' ), sort: false },
      { field: 'indicadorConsulta', header: this.navServicio.buscarMensaje( 'SISTEMAS.LBL_INDICADORCONSULTA' ), sort: false },
      { field: 'indicadorActualizacion', header: this.navServicio.buscarMensaje( 'SISTEMAS.LBL_INDICADORACTUALIZACION' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'sistemas.component' );

    this.sisServicio.getAll().subscribe( registros => {
      registros.map( ( s: Sistema ) => {
        if ( s.descripcion && s.descripcion.length > 100 ) {
          s.descripcionCorta = s.descripcion.substring( 0, 100 );
          s.mostrarDescripcion = true;
        } else {
          s.descripcionCorta = s.descripcion;
        }
        this.lisSistemas.push( s );
      } );
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/sistemas/agregar' ] );
  }

  editar( registro: Sistema ) {
    this.router.navigate( [ 'apl/sistemas/actualizar/' + registro.idSistema ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'sistemas.component', this.busqueda );
  }

  mostrarDescripcion( registro: Sistema ) {
    this.descripcion = registro.descripcion;
    this.mosDescripcion = true;
  }

  cerrarDescripcion() {
    this.mosDescripcion = false;
  }
}
